import { render } from "./HomeView.vue?vue&type=template&id=4954651b&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=4954651b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4954651b"]])

export default __exports__